import { ArmyListUnit } from '@Models';
import { ModelRuleView, TroopProfilView } from './ArmyListUnitProfilV2View';
import { OrganisationView } from './OrganisationView';

export class ArmyListUnitProfilV1View {
  item: ArmyListUnit;
  organisations: Array<OrganisationView>;
  unitId: number;
  troops: Array<TroopProfilView>;
  modelRules: Array<ModelRuleView>;

  constructor(params: ArmyListUnitProfilV1ViewParams) {
    this.item = params.item;
    this.organisations = params.organisations;
    this.unitId = params.unitId;
    this.troops = params.troops;
    this.modelRules = params.modelRules;
  }
}

export type ArmyListUnitProfilV1ViewParams = {
  item: ArmyListUnit;
  organisations: Array<OrganisationView>;
  unitId: number;
  troops: Array<TroopProfilView>;
  modelRules: Array<ModelRuleView>;
};
